var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRequire = function SvgIconRequire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5mm",
    height: "6.13mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14.17 17.39",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.94,3.63c-.13,0-.26-.05-.35-.15L.25,2.15C.05,1.95.05,1.63.25,1.44s.51-.2.71,0l.98.98L4.03.34c.2-.2.51-.2.71,0s.2.51,0,.71l-2.44,2.44c-.1.1-.23.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44,2.41h-6.95c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.95c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94,10.44c-.13,0-.26-.05-.35-.15l-1.34-1.34c-.2-.2-.2-.51,0-.71s.51-.2.71,0l.98.98,2.09-2.09c.2-.2.51-.2.71,0s.2.51,0,.71l-2.44,2.44c-.1.1-.23.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44,9.22h-6.95c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.95c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94,17.25c-.13,0-.26-.05-.35-.15l-1.34-1.34c-.2-.2-.2-.51,0-.71s.51-.2.71,0l.98.98,2.09-2.09c.2-.2.51-.2.71,0s.2.51,0,.71l-2.44,2.44c-.09.09-.22.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44,16.03h-6.95c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.95c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRequire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-require.80c9b9dbe0e7df20d0339278bd5e4d99.svg";